import { IconAngleLeft } from '@iwoca/icons';
import { IwocaLogo } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';
import styles from './MobileSignupLoader.module.css';
import { Button } from '../Button/Button';

const BASE_COLOR = 'var(--color-structure-95)';
const HIGHLIGHT_COLOR = 'var(--color-structure-100)';

export const MobileSignupLoader = () => {
  const { t } = useLingui();

  return (
    <SkeletonTheme baseColor={BASE_COLOR} highlightColor={HIGHLIGHT_COLOR}>
      <div className={styles.layout} data-testid="mobile-signup-loading">
        <span role="status" className={styles.srOnly}>
          {t`Loading`}
        </span>

        <header className={styles.header}>
          <Button
            variant="tertiary"
            size="small"
            iconOnly
            disabled
            aria-hidden="true"
            tabIndex={-1}
            className={styles.back}
          >
            <IconAngleLeft />
          </Button>
          <IwocaLogo color="red" className={styles.logo} />
        </header>

        <div className={styles.progress} aria-hidden="true">
          <div className={styles.track}>
            <div className={styles.bar} />
          </div>
          <Skeleton containerClassName={styles.stepCount} width={64} />
        </div>

        <div className={styles.body} aria-hidden="true">
          <Skeleton containerClassName={styles.stage} width="30%" />
          <div className={styles.heading}>
            <Skeleton width="80%" height={28} />
            <Skeleton width="55%" height={28} />
          </div>
          <div className={styles.content}>
            <Skeleton count={3} />
            <Skeleton width="70%" />
          </div>
        </div>

        <footer className={styles.footer}>
          <Button
            variant="primary"
            size="large"
            loading
            disabled
            className={styles.cta}
          >
            {t`Next step`}
          </Button>
        </footer>
      </div>
    </SkeletonTheme>
  );
};
